// extracted by mini-css-extract-plugin
module.exports = {"spinner":"PdN3usg9","spin":"ehi_oI4F","opacity-25":"vCZcnmQ1","opacity-75":"IzjxynL5"};